// AUTO GENERATED FILE - Changes WILL be lost.
// es - used as 'es' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Ticket de apuestas",
  "product.last60-row-single": "NBA Last 60 Partido único",
  "product.sb-english-single": "Partido de Soccerbet Inglés",
  "product.sb-italian-single": "Partido de Soccerbet Italiano",
  "product.sb-greek-single": "Partido de Soccerbet Griego",
  "product.sb-english-league": "Partido de liga Inglesa",
  "product.sb-italian-league": "Partido de liga Italiana",
  "product.sb-greek-league": "Partido de liga Griega",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Hacer apuesta",
  "betslip.clear": "Eliminar todo",
  "betslip.clearResult": "Eliminar",
  "betslip.noSelections": "Agregue selecciones para apostar",
  "betslip.notLoggedIn": "Inicia sesión para comenzar a apostar",
  "betslip.refresh": "Actualizar",
  "betslip.totalStake": "Total Apuesta",
  "betslip.noHistoryData": "No hay información de apuesta disponible",
  "betslip.openBets": "Apuestas abiertas",
  "betslip.betHistory": "Historial de apuestas",
  "betslip.betHistoryWon": "Ganada",
  "betslip.betHistoryLost": "Perdida",
  "loading.loading": "Cargando",
  "loading.account": "Cargando cuenta",
  "loading.league": "Cargando Liga",
  "loading.gameweeks": "Cargando semanas de juego",
  "loading.markets": "Cargando mercados",
  "loading.bethistory": "Cargando historial de apuestas",
  "login.loginRequired": "Necesario iniciar sesión",
  "login.loginToBet": "Inicia sesión para comenzar a apostar",
  "navigation.back": "Volver",
  "navigation.close": "Cerrar",
  "video.liveStreamAvailable": "Transmisión en vivo disponible",
  "video.logInToWatch": "Inicia sesión para ver",
  "error.error": "Error",
  "error.404": "Página no encontrada",
  "error.gameLaunchFailed": "No se pudo iniciar el juego.",
  "error.unknownErrorCode": "Error desconocido: {code}",
  "error.minUnitStakeLimitExceeded": "La apuesta mínima es {limit}",
  "error.maxUnitStakeLimitExceeded": "La apuesta máxima es {limit}",
  "error.minTotalStakeLimitExceeded": "La apuesta total mínima es {limit}",
  "error.maxTotalStakeLimitExceeded": "La apuesta total máxima es {limit}",
  "error.stakeInvalidMultiple": "La apuesta debe ser un múltiplo de {multiple}",
  "error.notPlaced": "No apostado",
  "error.wagerDisallowed": "Apuesta no permitida",
  "error.errorEventIsOff": "El evento ha comenzado",
  "multiplebet.Singles": "Sencillo",
  "multiplebet.Doubles": "Dobles",
  "multiplebet.Trebles": "Triples",
  "multiplebet.Accumulator": "Acumulado",
  "multiplebet.Perm 4-Folds": "4 - Múltiple",
  "multiplebet.Perm 5-Folds": "5 - Múltiple",
  "multiplebet.Perm 6-Folds": "6 - Múltiple",
  "multiplebet.Perm 7-Folds": "7 - Múltiple",
  "multiplebet.Perm 8-Folds": "8 - Múltiple",
  "multiplebet.Perm 9-Folds": "9 - Múltiple",
  "error.excess_bets": "Máximo de {limit} apuestas simultáneas en el ticket de apuesta; favor ajustar.",
  "product.sb-turkish-league": "Liga Turka de Soccerbet",
  "error.minBetslipLimitExceeded": "El mínimo total en el ticket de apuesta es {limit}",
  "error.maxBetslipLimitExceeded": "El máximo total en el ticket de apuesta es {limit}",
  "error.exceededMaxPayout": "El monto máximo a pagar es de {limit}; favor reducir su apuesta.",
  "betslip.potentialReturns": "Posible retorno",
  "betslip.taxDisclaimer": "Todas sus ganancias netas se gravan en el momento de la liquidación de la apuesta. El importe del impuesto se calculará en función de la ganancia potencial de la apuesta.",
  "error.maintenanceEnabled": "El servidor está actualmente en mantenimiento.",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palace",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "West Ham",
  "sb-english.team.WOL": "Wolves",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATHENS",
  "sb-greek.team.APS": "APOLLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS THESSALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLYMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIAS",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genoa",
  "sb-italian.team.INT": "Inter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "No más apuestas",
  "playtime": "Tiempo de juego",
  "gameId": "ID de juego",
  "noGames": "No hay partidos disponibles. Revise pronto",
  "Home": "Local",
  "Away": "Visita",
  "Visitor": "Visitante",
  "rules": "Reglas",
  "soccerbet.gameWeek": "PARTIDOS DE LA SEMANA",
  "soccerbet.noGameWeeks": "No hay semanas de juego disponibles. Vuelva a consultar pronto.",
  "soccerbet.league": "TABLA DE LIGA",
  "soccerbet.table.name": "Equipo",
  "soccerbet.table.won": "V",
  "soccerbet.table.drawn": "E",
  "soccerbet.table.lost": "D",
  "soccerbet.table.points": "PT",
  "market.abbr.Both Teams To Score": "AEA",
  "market.Both Teams To Score": "Ambos anotan",
  "market.Over / Under": "Más/Menos de",
  "market.Double Chance": "Doble oportunidad",
  "market.Match Result": "Resultado del partido",
  "market.Exact Goals": "Goles exactos",
  "market.Correct Score": "Resultado correcto",
  "market.Match Result Both Score": "Resultado del partido y ambos anotan",
  "market.Result Und/Over 1.5 Total Goals": "Resultado del partido y Más/Menos de 1.5 goles",
  "market.Result Und/Over 2.5 Total Goals": "Resultado del partido y Más/Menos de 2.5 goles",
  "market.Under Over 1.5 Total Goals": "Más/Menos de 1.5 goles en total",
  "market.Under Over 2.5 Total Goals": "Más/Menos de 2.5 goles en total",
  "market.Under Over 3.5 Total Goals": "Más/Menos de 3.5 goles en total",
  "market.Under Over 4.5 Total Goals": "Más/Menos de 4.5 goles en total",
  "market.Total Goals 1 To 2": "Total de goles 1 a 2",
  "market.Total Goals 1 To 3": "Total de goles 1 a 3",
  "market.Total Goals 1 To 4": "Total de goles 1 a 4",
  "market.Total Goals 2 To 3": "Total de goles 2 a 3",
  "market.Total Goals 2 To 4": "Total de goles 2 a 4",
  "market.Under Over 1.5 Home Goals": "Más/Menos de 1.5 goles del local",
  "market.Under Over 1.5 Away Goals": "Más/Menos de 1.5 goles del visitante",
  "market.Home Team Exact Goals": "Goles exactos equipo local",
  "market.Away Team Exact Goals": "Goles exactos equipo visitante",
  "selection.Yes": "Si",
  "selection.No": "No",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+Si",
  "selection.1+No": "1+No",
  "selection.X+Yes": "X+Si",
  "selection.X+No": "X+No",
  "selection.2+Yes": "2+Si",
  "selection.2+No": "2+No",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "Me",
  "selection.O": "Ma",
  "selection.1+O": "1+Ma",
  "selection.X+O": "X+Ma",
  "selection.2+O": "2+Ma",
  "selection.1+U": "1+Me",
  "selection.X+U": "X+Me",
  "selection.2+U": "2+Me",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1X",
  "selection.TID_DRAW_OR_AWAY_WIN": "X2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "MÁS DE",
  "selection.Under": "MENOS DE",
  "sb-english.team.abbr.ARS": "ARS",
  "sb-english.team.abbr.AST": "AST",
  "sb-english.team.abbr.BHA": "BHA",
  "sb-english.team.abbr.BOU": "BOU",
  "sb-english.team.abbr.BUR": "BUR",
  "sb-english.team.abbr.CHE": "CHE",
  "sb-english.team.abbr.CRY": "CRY",
  "sb-english.team.abbr.EVE": "EVE",
  "sb-english.team.abbr.LEI": "LEI",
  "sb-english.team.abbr.LIV": "LIV",
  "sb-english.team.abbr.MNC": "MNC",
  "sb-english.team.abbr.MNU": "MNU",
  "sb-english.team.abbr.NEW": "NEW",
  "sb-english.team.abbr.SOU": "SOU",
  "sb-english.team.abbr.TOT": "TOT",
  "sb-english.team.abbr.WAT": "WAT",
  "sb-english.team.abbr.WHU": "WHU",
  "sb-english.team.abbr.WOL": "WOL",
  "sb-english.team.abbr.NOR": "NOR",
  "sb-english.team.abbr.SHU": "SHU",
  "sb-english.team.abbr.LEE": "LEE",
  "sb-english.team.abbr.FUL": "FUL",
  "sb-english.team.abbr.WBA": "WBA",
  "sb-italian.team.abbr.MIL": "MIL",
  "sb-italian.team.abbr.ATA": "ATA",
  "sb-italian.team.abbr.BOL": "BOL",
  "sb-italian.team.abbr.BRE": "BRE",
  "sb-italian.team.abbr.CAG": "CAG",
  "sb-italian.team.abbr.CHI": "CHI",
  "sb-italian.team.abbr.FIO": "FIO",
  "sb-italian.team.abbr.GEN": "GEN",
  "sb-italian.team.abbr.INT": "INT",
  "sb-italian.team.abbr.JUV": "JUV",
  "sb-italian.team.abbr.LAZ": "LAZ",
  "sb-italian.team.abbr.NAP": "NAP",
  "sb-italian.team.abbr.ROM": "ROM",
  "sb-italian.team.abbr.SAM": "SAM",
  "sb-italian.team.abbr.UDI": "UDI",
  "sb-italian.team.abbr.VER": "VER",
  "sb-greek.team.abbr.AEK": "AEK",
  "sb-greek.team.abbr.APS": "APS",
  "sb-greek.team.abbr.ARI": "ARI",
  "sb-greek.team.abbr.AST": "AST",
  "sb-greek.team.abbr.ATR": "ATR",
  "sb-greek.team.abbr.GIA": "GIA",
  "sb-greek.team.abbr.LEV": "LEV",
  "sb-greek.team.abbr.OFI": "OFI",
  "sb-greek.team.abbr.OLM": "OLM",
  "sb-greek.team.abbr.PTK": "PTK",
  "sb-greek.team.abbr.PNS": "PNS",
  "sb-greek.team.abbr.PAO": "PAO",
  "sb-greek.team.abbr.PLT": "PLT",
  "sb-greek.team.abbr.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZONSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "BURSASPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İST BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "AD. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "Ç. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "sb-turkish.team.abbr.AKB": "AKB",
  "sb-turkish.team.abbr.BES": "BES",
  "sb-turkish.team.abbr.FEN": "FEN",
  "sb-turkish.team.abbr.GAL": "GAL",
  "sb-turkish.team.abbr.TRA": "TRA",
  "sb-turkish.team.abbr.ANT": "ANT",
  "sb-turkish.team.abbr.GEN": "GEN",
  "sb-turkish.team.abbr.KAS": "KAS",
  "sb-turkish.team.abbr.BUR": "BUR",
  "sb-turkish.team.abbr.KAY": "KAY",
  "sb-turkish.team.abbr.SIV": "SIV",
  "sb-turkish.team.abbr.IBA": "IBA",
  "sb-turkish.team.abbr.HAT": "HAT",
  "sb-turkish.team.abbr.ADS": "ADS",
  "sb-turkish.team.abbr.ALT": "ALT",
  "sb-turkish.team.abbr.GAZ": "GAZ",
  "sb-turkish.team.abbr.GOZ": "GOZ",
  "sb-turkish.team.abbr.KON": "KON",
  "sb-turkish.team.abbr.CRS": "CRS",
  "sb-turkish.team.abbr.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "sb-english.team.abbr.BRE": "BRE",
  "market.Overall Winner": "GANADOR DEL PARTIDO",
  "market.Last60 Winner": "GANADOR DE LOS ÚLTIMOS 60",
  "market.Both Teams Over 2.5 Last60": "AMBOS ANOTAN MÁS DE 2.5 EN LOS ÚLTIMOS 60",
  "market.Both Teams Over 3.5 Last60": "AMBOS ANOTAN MÁS DE 3.5 EN LOS ÚLTIMOS 60",
  "market.First Team To Score In Last60": "PRIMERO EN ANOTAR EN LOS ÚLTIMOS 60",
  "market.Last60 Winner And Winning Margin": "GANADOR DE LOS ÚLTIMOS 60 Y MARGEN DE VICTORIA",
  "market.First To Score 4 Points Last60": "PRIMERO EN ANOTAR 4 PTS EN LOS ÚLTIMOS 60",
  "market.Home Under/Over 4.5 Last60": "{home} MÁS/MENOS DE 4.5 EN LOS ÚLTIMOS 60",
  "market.Visitor Under/Over 4.5 Last60": "{visitor} MÁS/MENOS DE 4.5 EN LOS ÚLTIMOS 60",
  "market.Home Under/Over 5.5 Last60": "{home} MÁS/MENOS DE 5.5 EN LOS ÚLTIMOS 60",
  "market.Visitor Under/Over 5.5 Last60": "{visitor} MÁS/MENOS DE 5.5 EN LOS ÚLTIMOS 60",
  "market.Last60 Winner And O/U 11.5": "GANADOR DE LOS ÚLTIMOS 60 Y MÁS/MENOS DE 11.5",
  "market.Last60 Points Difference": "DIFERENCIA DE PUNTOS EN LOS ÚLTIMOS 60",
  "market.Total 3-Pointers Last60": "TOTAL DE 3-PUNTOS EN LOS ÚLTIMOS 60",
  "selection.Home & 1-3": "{home} & 1-3",
  "selection.Home & 4-6": "{home} & 4-6",
  "selection.Home & 7-9": "{home} & 7-9",
  "selection.Home & 10-12": "{home} & 10-12",
  "selection.Home & 13+": "{home} & 13+",
  "selection.Visitor & 1-3": "{visitor} & 1-3",
  "selection.Visitor & 4-6": "{visitor} & 4-6",
  "selection.Visitor & 7-9": "{visitor} & 7-9",
  "selection.Visitor & 10-12": "{visitor} & 10-12",
  "selection.Visitor & 13+": "{visitor} & 13+",
  "selection.Home & Over": "{home} & MÁS",
  "selection.Home & Under": "{home} & MENOS",
  "selection.Visitor & Over": "{visitor} & MÁS",
  "selection.Visitor & Under": "{visitor} & MENOS",
  "last60.team.ATL": "Atlanta Hawks",
  "last60.team.BKN": "Brooklyn Nets",
  "last60.team.BOS": "Boston Celtics",
  "last60.team.CHA": "Charlotte Hornets",
  "last60.team.CHI": "Chicago Bulls",
  "last60.team.CLE": "Cleveland Cavaliers",
  "last60.team.DAL": "Dallas Mavericks",
  "last60.team.DEN": "Denver Nuggets",
  "last60.team.DET": "Detroit Pistons",
  "last60.team.GSW": "Golden State Warriors",
  "last60.team.HOU": "Houston Rockets",
  "last60.team.IND": "Indiana Pacers",
  "last60.team.LAC": "LA Clippers",
  "last60.team.LAL": "Los Angeles Lakers",
  "last60.team.MEM": "Memphis Grizzlies",
  "last60.team.MIA": "Miami Heat",
  "last60.team.MIL": "Milwaukee Bucks",
  "last60.team.MIN": "Minnesota Timberwolves",
  "last60.team.NOP": "New Orleans Pelicans",
  "last60.team.NYK": "New York Knicks",
  "last60.team.OKC": "Oklahoma City Thunder",
  "last60.team.ORL": "Orlando Magic",
  "last60.team.PHI": "Philadelphia 76ers",
  "last60.team.PHX": "Phoenix Suns",
  "last60.team.POR": "Portland Trail Blazers",
  "last60.team.SAC": "Sacramento Kings",
  "last60.team.SAS": "San Antonio Spurs",
  "last60.team.TOR": "Toronto Raptors",
  "last60.team.UTA": "Utah Jazz",
  "last60.team.WAS": "Washington Wizards",
  "last60.team.abbr.ATL": "ATL",
  "last60.team.abbr.BKN": "BKN",
  "last60.team.abbr.BOS": "BOS",
  "last60.team.abbr.CHA": "CHA",
  "last60.team.abbr.CHI": "CHI",
  "last60.team.abbr.CLE": "CLE",
  "last60.team.abbr.DAL": "DAL",
  "last60.team.abbr.DEN": "DEN",
  "last60.team.abbr.DET": "DET",
  "last60.team.abbr.GSW": "GSW",
  "last60.team.abbr.HOU": "HOU",
  "last60.team.abbr.IND": "IND",
  "last60.team.abbr.LAC": "LAC",
  "last60.team.abbr.LAL": "LAL",
  "last60.team.abbr.MEM": "MEM",
  "last60.team.abbr.MIA": "MIA",
  "last60.team.abbr.MIL": "MIL",
  "last60.team.abbr.MIN": "MIN",
  "last60.team.abbr.NOP": "NOP",
  "last60.team.abbr.NYK": "NYK",
  "last60.team.abbr.OKC": "OKC",
  "last60.team.abbr.ORL": "ORL",
  "last60.team.abbr.PHI": "PHI",
  "last60.team.abbr.PHX": "PHX",
  "last60.team.abbr.POR": "POR",
  "last60.team.abbr.SAC": "SAC",
  "last60.team.abbr.SAS": "SAS",
  "last60.team.abbr.TOR": "TOR",
  "last60.team.abbr.UTA": "UTA",
  "last60.team.abbr.WAS": "WAS",
  "selection.Home": "{home}",
  "selection.Visitor": "{visitor}",
  "market.Total 3-Pointers Last60 1-6": "TOTAL DE 3-PUNTOS EN LOS ÚLTIMOS 60",
  "market.Last60 Winning Margin 1": "DIFERENCIA DE PUNTOS EN LOS ÚLTIMOS 60",
  "market.Last60 Winning Margin 2": "MÁRGEN DE VICTORIA EN LOS ÚLTIMOS 60",
  "market.Last60 Winning Margin 3": "DIFERENCIA DE PUNTOS EN LOS ÚLTIMOS 60",
  "market.Last60 Winner & Winning Margin 1": "GANADOR DE LOS ÚLTIMOS 60 Y MÁRGEN DE VICTORIA",
  "market.Last60 Winner & Winning Margin 2": "GANADOR DE LOS ÚLTIMOS 60 Y MÁRGEN DE VICTORIA",
  "market.Last60 Winner & Winning Margin 3": "GANADOR DE LOS ÚLTIMOS 60 Y MÁRGEN DE VICTORIA",
  "market.Total 3-Pointers Last60 1-3+": "TOTAL DE 3-PUNTOS EN LOS ÚLTIMOS 60",
  "selection.Home & 1": "{home} & 1",
  "selection.Home & 2": "{home} & 2",
  "selection.Home & 3": "{home} & 3",
  "selection.Home & 4": "{home} & 4",
  "selection.Home & 5": "{home} & 5",
  "selection.Home & 6": "{home} & 6",
  "selection.Home & 7": "{home} & 7",
  "selection.Home & 8": "{home} & 8",
  "selection.Home & 9": "{home} & 9",
  "selection.Home & 10": "{home} & 10",
  "selection.Home & 11": "{home} & 11",
  "selection.Home & 12": "{home} & 12",
  "selection.Home & 13": "{home} & 13",
  "selection.Home & 14": "{home} & 14",
  "selection.Home & 15": "{home} & 15",
  "selection.Home & 16": "{home} & 16",
  "selection.Home & 17+": "{home} & 17",
  "selection.Visitor & 1": "{visitor} & 1",
  "selection.Visitor & 2": "{visitor} & 2",
  "selection.Visitor & 3": "{visitor} & 3",
  "selection.Visitor & 4": "{visitor} & 4",
  "selection.Visitor & 5": "{visitor} & 5",
  "selection.Visitor & 6": "{visitor} & 6",
  "selection.Visitor & 7": "{visitor} & 7",
  "selection.Visitor & 8": "{visitor} & 8",
  "selection.Visitor & 9": "{visitor} & 9",
  "selection.Visitor & 10": "{visitor} & 10",
  "selection.Visitor & 11": "{visitor} & 11",
  "selection.Visitor & 12": "{visitor} & 12",
  "selection.Visitor & 13": "{visitor} & 13",
  "selection.Visitor & 14": "{visitor} & 14",
  "selection.Visitor & 15": "{visitor} & 15",
  "selection.Visitor & 16": "{visitor} & 16",
  "selection.Visitor & 17+": "{visitor} & 17+",
  "selection.Home & 1-2": "{home} & 1-2",
  "selection.Home & 3-4": "{home} & 3-4",
  "selection.Home & 5-6": "{home} & 5-6",
  "selection.Home & 7-8": "{home} & 7-8",
  "selection.Home & 9-10": "{home} & 9-10",
  "selection.Home & 11-12": "{home} & 11-12",
  "selection.Home & 13-14": "{home} & 13-14",
  "selection.Home & 15-16": "{home} & 15-16",
  "selection.Visitor & 1-2": "{visitor} & 1-2",
  "selection.Visitor & 3-4": "{visitor} & 3-4",
  "selection.Visitor & 5-6": "{visitor} & 5-6",
  "selection.Visitor & 7-8": "{visitor} & 7-8",
  "selection.Visitor & 9-10": "{visitor} & 9-10",
  "selection.Visitor & 11-12": "{visitor} & 11-12",
  "selection.Visitor & 13-14": "{visitor} & 13-12",
  "selection.Visitor & 15-16": "{visitor} & 15-16"
}
